<template>
  <div class="section-board">
    <header class="tree__container">
      <h2 class="tree__title">Construir mi secuencia</h2>
    </header>

    <template v-if="!nodes?.length">
      <section class="empty__container">
        <p>
          Selecciona la acción con la que desees iniciar tu secuencia para comunicarte con tus
          nuevos contactos
        </p>

        <!-- {{ sequence?.channels_customers }} -->
        <div class="card__container">
          <CreateNodeCard
            v-for="nodeOption in nodeOptions"
            :key="nodeOption.type"
            :type="nodeOption.type"
            :disabled="sequence.status === SequenceStatus.Active || validateIdentifiers(nodeOption)"
            :show-tooltip="validateIdentifiers(nodeOption)"
            :text="nodeOption.text"
            @click="handleCreateNode"
          />
        </div>
      </section>
    </template>

    <template v-else>
      <CustomScrollbar class="scroll">
        <NodesTree
          :nodes="nodes"
          :parent-node="undefined"
          :sequence="sequence"
          @open-settings="handleOpen"
          @close-settings="(id) => emit('closeDrawer', id)"
          @update="emit('update')"
        />
      </CustomScrollbar>
    </template>
  </div>
</template>

<script setup lang="ts">
// import { BotStatus, BotType, NodeType } from "@/app/ivr/bot/utils/enums";
// import { nodeServices } from "@/app/ivr/bot/services/NodeServices";
// import { FetchNodesKey, BotNodesKey, BotDetailsKey } from "@/@types/ivr/symbols";
// import { ResponseError } from "@/app/shared/utils/httpManager";
import { Sequence, SequenceNode, SequenceNodeType, SequenceStatus } from "@/@types/flows/sequences";
import {
  addNodeOptions,
  addNodeOptionsMultichannel,
} from "@/app/flows/sequences/utils/addNodeOptions";

import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";
import CreateNodeCard from "@/app/flows/sequences/components/cards/CreateNodeCard.vue";
import NodesTree from "@/app/flows/sequences/components/nodes/NodesTree.vue";
import { computed } from "vue";
import { SequenceType } from "@/app/flows/sequences/utils/enums";
import { ChannelType } from "@/app/shared/utils/enums";

// import CreateNodeCard from "@/app/ivr/bot/components/cards/CreateNodeCard.vue";
// import NodesTree from "@/app/ivr/bot/components/tree/NodesTree.vue";
// type: 1 Progresivo Automático | 2 Secuencia Multicanal
const props = defineProps<{ sequence: Sequence; nodes: SequenceNode[]; type: number }>();

const emit = defineEmits<{
  openDrawer: [node: SequenceNode];
  closeDrawer: [nodesIds: number[]];
  create: [nodeType: SequenceNodeType];
  update: [];
}>();

const nodeOptions = computed(() => {
  return props.sequence.sequence_type == SequenceType.AutomaticProgressive ? addNodeOptions : addNodeOptionsMultichannel;
});
const handleCreateNode = async (nodeType: SequenceNodeType) => {
  emit("create", nodeType);
  // try {
  //   // await nodeServices.create(Number(route.params.id), type);
  // } catch (error) {
  //   const errorMessage =
  //     error instanceof ResponseError ? error.getErrorMessage() : "Ha ocurrido un error";

  //   message.error(errorMessage);
  // }

  // fetchNodes?.();
};

const searchIdentifier = (channelType: number) => {
  const itemIndex = props.sequence.channels_customers.findIndex((el) => (el.channel?.id == channelType));
  return itemIndex > -1;
};

const validateIdentifiers = (nodeOption: any) => {
  if (nodeOption.type == SequenceNodeType.TimeInterval || nodeOption.type == SequenceNodeType.AutomaticCall)
    return false;
  else {
    let channelType: number = 0;
    switch (nodeOption.type) {
      case SequenceNodeType.Email:
        channelType = ChannelType.Email;
        break;
      case SequenceNodeType.Whatsapp:
        channelType = ChannelType.Whatsapp;
        break;
      case SequenceNodeType.Sms:
        channelType = ChannelType.Sms;
        break;
    }
    return !searchIdentifier(channelType);
  }
}

const handleOpen = (node: SequenceNode) => emit("openDrawer", node);
</script>

<style scoped lang="sass">
.section-board
  height: 100%
  // border-top: 1px solid $gray-5
  background-color: #FFFFFF
  flex: 1 1 auto

.card__container
  display: flex
  justify-content: center
  gap: 16px

.empty__container
  padding: 12px 28px
  text-align: center
  color: $gray-8

.tree
  &__container
    padding: 12px 16px
    border-bottom: 1px solid #F0F0F0

  &__title
    font-weight: 400
    font-size: 16px
    color: $gray-9
    margin: 0

.scroll
  padding: 12px 16px
  height: calc(100% - 51px)
</style>
